import { faExclamationTriangle } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getSessionData } from "redux/actions";

const fetchSessionData = async (sessionId, dispatch, setSessionData) => {
    const sessionData = await dispatch(getSessionData(sessionId));

    setSessionData(sessionData);
};

const RailCompareDraggableListItem = ({ sessionId, comparableSessions, selectedSession, selectedItemRef, handleClick, style }) => {
    const selectedSessionInRange = comparableSessions.includes(sessionId);
    const isSelectedSession = sessionId === selectedSession;
    const [sessionData, setSessionData] = useState(null);
    const dispatch = useDispatch();

    useEffect(() => {
        fetchSessionData(sessionId, dispatch, setSessionData);
    }, [dispatch, sessionId]);

    const _style = { ...style, border: `2px solid ${isSelectedSession ? "#b09aee" : "transparent"}` };

    if (!sessionData) {
        return (
            <div
                ref={isSelectedSession ? selectedItemRef : null}
                className={`inspection-default-button w-full ${isSelectedSession ? "active" : ""} animate-pulse`}
                style={_style}
            />
        );
    }

    return (
        <div
            ref={isSelectedSession ? selectedItemRef : null}
            className={`inspection-default-button center w-full flex-col ${isSelectedSession ? "active" : ""} justify-between items-start overflow-hidden `}
            onClick={() => {
                handleClick(sessionId);
            }}
            style={_style}>
            <div
                className="flex w-full justify-between"
                style={{ gap: "8px" }}>
                <span
                    className="flex items-center overflow-hidden text-ellipsis text-nowrap whitespace-nowrap"
                    style={{ gap: "4px" }}>
                    {selectedSessionInRange ? (
                        `# ${sessionId}`
                    ) : (
                        <>
                            <Tooltip title="Selected session no longer in current bounds">
                                <FontAwesomeIcon icon={faExclamationTriangle} />
                            </Tooltip>
                            {sessionId}
                        </>
                    )}
                </span>
                <span>{new Date(parseFloat(sessionData.first_seen) * 1000).toDateString()}</span>
            </div>
            <span className="flex-1">{sessionData.route_name}</span>
        </div>
    );
};

export default RailCompareDraggableListItem;
